export const DPP_PROXY_BASE_PATH = '/api/dpp';

export const DPP_JOURNEY_QUERY_KEY = 'dpp_j';

export const DPP_JOURNEY_STORAGE_KEY = 'dppJourneyId';

export const DPP_JOURNEY_ID_PATTERN =
	/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const DPP_MAX_EVENTS_PER_BATCH = 20;

export const DPP_REQUEST_TIMEOUT_MS = 15_000;

export const DPP_JSON_API_CONTENT_TYPE = 'application/vnd.api+json';

export const DPP_USER_DATA_KEY = {
	eventsBaseUrl: 'dpp_events_base_url',
	eventsApiKey: 'dpp_events_api_key',
	landingHref: 'dpp_landing_href',
} as const;

export const DPP_UPSTREAM_EVENTS_PATH = 'v1/events';

export const toDppUpstreamPromotionPath = (memberId: string) =>
	`v1/members/${encodeURIComponent(memberId)}/promotion`;

export const toDppPromotionProxyPath = (memberId: string) =>
	`${DPP_PROXY_BASE_PATH}/members/${encodeURIComponent(memberId)}/promotion`;

export const DPP_PROMOTION_TIMEOUT_MS = 5_000;

export const DPP_HCL_ID_PATTERN = /^[0-9A-Za-z_-]{1,64}$/;

export const DPP_MEMBER_ID_PATTERN = /^\d{1,18}$/;

export const DPP_STORE_ID_PATTERN = /^\d+$/;

export const DPP_MAX_COUPONS_PER_ORDER = 5;

export const DPP_ORDER_COMPLETION_TIMEOUT_MS = 3_000;

export const DPP_ORDER_COMPLETION_STORAGE_PREFIX = 'dpp-order-completion:';

export const DPP_TRACKED_ONCE_STORAGE_PREFIX = 'dpp-tracked-once:';

export const HCL_ORDER_STATUS = {
	pendingCart: 'P',
	cancelled: 'X',
} as const;

export const HCL_NOT_PLACED_ORDER_STATUSES: readonly string[] = [
	HCL_ORDER_STATUS.pendingCart,
	HCL_ORDER_STATUS.cancelled,
];

export const HCL_GUEST_REGISTER_TYPE = 'G';
